<template>
  <div class="device-stats-container">
    <el-card class="box-card">
      <div class="toolbar">
        <el-button-group>
          <el-button size="mini" :type="preset === 'today' ? 'primary' : 'default'" @click="setPreset('today')">今日</el-button>
          <el-button size="mini" :type="preset === 'yesterday' ? 'primary' : 'default'"
            @click="setPreset('yesterday')">昨日</el-button>
          <el-button size="mini" :type="preset === 'week' ? 'primary' : 'default'" @click="setPreset('week')">本周</el-button>
          <el-button size="mini" :type="preset === 'month' ? 'primary' : 'default'" @click="setPreset('month')">本月</el-button>
          <el-button size="mini" :type="preset === 'custom' ? 'primary' : 'default'"
            @click="setPreset('custom')">自定义</el-button>
        </el-button-group>
        <el-date-picker v-model="dateRange[0]" type="date" size="mini" placeholder="开始日期"
          style="margin-left:10px;width:140px" :disabled="preset !== 'custom'" />
        <span style="margin:0 6px;color:#909399">至</span>
        <el-date-picker v-model="dateRange[1]" type="date" size="mini" placeholder="结束日期" style="width:140px"
          :disabled="preset !== 'custom'" />
        <el-select v-model="region" size="mini" placeholder="请选择区域" style="margin-left:10px;width:120px">
          <el-option v-for="o in regionOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
        <el-select v-model="area" size="mini" placeholder="小区" style="margin-left:10px;width:120px">
          <el-option v-for="o in areaOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
        <el-checkbox v-model="showDetails" style="margin-left:10px">详指标</el-checkbox>
        <el-button size="mini" type="primary" style="margin-left:10px" @click="fetchData">筛选</el-button>
        <el-button size="mini" style="margin-left:10px" @click="exportCSV">导出</el-button>
      </div>

      <div class="summary">
        投递量统计：<b>{{ formatDecimal(totalWeight) }}</b> kg
        投递次数统计：<b>{{ formatNumber(totalTimes) }}</b> 次
      </div>

      <div ref="chart" class="chart"></div>
    </el-card>

    <el-card class="box-card" style="margin-top: 16px;">
      <el-table ref="table" :data="tableData" height="520" border style="width: 100%;" size="small">
        <el-table-column prop="name" label="设备" min-width="120" show-overflow-tooltip align="center" />
        <el-table-column prop="times" label="投递次数" min-width="80" show-overflow-tooltip align="center" />
        <el-table-column prop="weight" label="投递量" min-width="80" show-overflow-tooltip align="center" />
        <el-table-column prop="memberCount" label="会员数" min-width="70" show-overflow-tooltip align="center" />
        <el-table-column prop="participantCount" label="参与人数" min-width="80" show-overflow-tooltip align="center" />
        <!-- <el-table-column prop="topDeliverUserId" label="榜首用户ID" min-width="100" show-overflow-tooltip align="center" />
        <el-table-column prop="topDeliverUserPhone" label="榜首手机" min-width="110" show-overflow-tooltip align="center" />
        <el-table-column prop="topDeliverCount" label="榜首次数" min-width="80" show-overflow-tooltip align="center" /> -->
        <el-table-column prop="memberAvgWeight" label="会员均投" min-width="80" show-overflow-tooltip align="center" />
        <el-table-column prop="participantAvgTimes" label="参与均投" min-width="80" show-overflow-tooltip align="center" />
        <el-table-column prop="actualDays" label="查询天数" min-width="80" show-overflow-tooltip align="center" />
        <el-table-column prop="dailyAvg" label="日平均" min-width="80" show-overflow-tooltip align="center" />
        <el-table-column prop="enabledDays" label="启用天数" min-width="80" show-overflow-tooltip align="center" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getDeviceMetrics } from '@/api/statistics'

export default {
  name: 'DeviceDeliveryStats',
  data() {
    return {
      preset: 'today',
      dateRange: [null, null],
      region: '',
      area: '',
      showDetails: false,
      regionOptions: [{ label: '全部', value: '' }],
      areaOptions: [{ label: '全部', value: '' }],
      totalWeight: 0,
      totalTimes: 0,
      tableData: [],
      chartInstance: null
    }
  },
  mounted() {
    this.initPreset()
    this.initChart()
    this.fetchData()
  },
  methods: {
    getCompanyId() {
      const s = this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.userInfo
      const fromStore = (s && s.company_id) || ''
      const fromLocal = localStorage.getItem('company_id') || ''
      return fromStore || fromLocal || ''
    },
    formatNumber(n) {
      if (n === null || n === undefined || n === '') return '0'
      const num = Number(n)
      if (Number.isNaN(num)) return String(n)
      return String(Math.trunc(num))
    },
    formatDateTime(d, endOfDay = false) {
      const pad = n => String(n).padStart(2, '0')
      const y = d.getFullYear(), m = pad(d.getMonth() + 1), day = pad(d.getDate())
      const hh = endOfDay ? '23' : pad(d.getHours())
      const mm = endOfDay ? '59' : pad(d.getMinutes())
      const ss = endOfDay ? '59' : pad(d.getSeconds())
      return `${y}-${m}-${day} ${hh}:${mm}:${ss}`
    },
    initPreset() {
      const now = new Date()
      const start = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)
      this.dateRange = [start, now]
    },
    setPreset(p) {
      this.preset = p
      const now = new Date()
      if (p === 'today') {
        this.dateRange = [new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0), now]
      } else if (p === 'yesterday') {
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 0, 0, 0)
        const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59)
        this.dateRange = [start, end]
      } else if (p === 'week') {
        const day = now.getDay() || 7
        const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - day + 1, 0, 0, 0)
        this.dateRange = [start, now]
      } else if (p === 'month') {
        const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0)
        this.dateRange = [start, now]
      } else {
        this.preset = 'custom'
      }
      this.fetchData()
    },
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart)
    },
    buildChartOption(labels, series) {
      return {
        tooltip: {
          trigger: 'axis', formatter: (params) => {
            const p = Array.isArray(params) ? params[0] : params
            const v = Number(p.data || 0).toFixed(2)
            return `${p.axisValue}<br/>投递量: ${v} Kg`
          }
        },
        grid: { left: '2%', right: '3%', top: '6%', bottom: '10%', containLabel: true },
        xAxis: { type: 'category', data: labels, axisLabel: { interval: 0, rotate: 30 } },
        yAxis: { type: 'value', axisLabel: { formatter: (value) => `${Number(value).toFixed(2)} Kg` } },
        series: [{
          type: 'bar',
          name: '投递量(Kg)',
          barWidth: '60%',
          itemStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#66ccff' }, { offset: 1, color: '#3399ff' }]) },
          data: series
        }]
      }
    },
    formatDecimal(n) {
      const num = Number(n)
      if (Number.isNaN(num)) return '0.00'
      return num.toFixed(2)
    },
    normalizeRow(row) {
      const name = row.device_name || row.name || '-'
      const isOnline = row.is_online
      const times = row.deliver_count || row.times || 0
      const weight = row.deliver_weight || row.value || row.weight || 0
      const memberCount = row.members_count || 0
      const participantCount = row.participants_count || 0
      const memberAvgWeight = row.avg_deliver_per_member || 0
      const participantAvgTimes = row.avg_deliver_per_participant || 0
      const topDeliverUserId = row.top_deliver_user_id || '-'
      const topDeliverUserPhone = row.top_deliver_user_phone || '-'
      const topDeliverCount = row.top_deliver_count || 0
      const enabledDays = row.enabled_days || 0
      const dailyAvg = row.daily_avg_weight || 0
      const actualDays = row.actual_days || 0
      return {
        name,
        isOnline,
        times: Number(times) || 0,
        weight: Number(weight) || 0,
        memberCount: Number(memberCount) || 0,
        participantCount: Number(participantCount) || 0,
        memberAvgWeight: Number(memberAvgWeight) || 0,
        topDeliverUserId,
        topDeliverUserPhone,
        topDeliverCount: Number(topDeliverCount) || 0,
        participantAvgTimes: Number(participantAvgTimes) || 0,
        enabledDays: Number(enabledDays) || 0,
        dailyAvg: Number(dailyAvg) || 0,
        actualDays: Number(actualDays) || 0
      }
    },
    escapeCSV(s) {
      const str = String(s)
      if (str.includes('"') || str.includes(',') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"'
      }
      return str
    },
    exportCSV() {
      const headers = ['设备', '状态', '投递次数(次)', '投递量(Kg)', '会员数', '参与会员', '会员投递均值', '参与会员的投递次数', '启用天数', '日平均', '最高次数用户编号', '最高次数用户手机号', '最高户投递次数']
      const rows = this.tableData.map(r => [r.name, r.isOnline ? '在线' : '离线', r.times, r.weight, r.memberCount, r.participantCount, r.memberAvgWeight, r.participantAvgTimes, r.enabledDays, r.dailyAvg, r.topDeliverUserId, r.topDeliverUserPhone, r.topDeliverCount])
      const totalRow = ['合计', '', this.formatNumber(this.totalTimes), this.formatNumber(this.totalWeight), '', '', '', '', '', '', '', '', '']
      const lines = [headers.join(','), ...rows.map(a => a.map(v => this.escapeCSV(v)).join(',')), totalRow.map(v => this.escapeCSV(v)).join(',')]
      const bom = '\ufeff'
      const csvContent = bom + lines.join('\r\n')
      const from = this.formatDateTime(new Date(this.dateRange[0] || new Date()), false)
      const to = this.formatDateTime(new Date(this.dateRange[1] || new Date()), true)
      const filename = `设备投递量统计_${from.replace(/[:\s]/g, '-')}_${to.replace(/[:\s]/g, '-')}.csv`
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    async fetchData() {
      try {
        const companyId = this.getCompanyId()
        if (!companyId) return
        const startDate = this.dateRange[0] || new Date()
        const endDate = this.dateRange[1] || new Date()
        const from = this.formatDateTime(new Date(startDate), false)
        const to = this.formatDateTime(new Date(endDate), true)
        const res = await getDeviceMetrics({ company_id: companyId, from, to })
        const body = res
        const arr = Array.isArray(body && body.data) ? body.data : []
        const rows = arr.map(this.normalizeRow)
        rows.sort((a, b) => (b.weight - a.weight))
        this.tableData = rows
        const labels = rows.map(r => r.name)
        const series = rows.map(r => Number(Number(r.weight || 0).toFixed(2)))
        this.totalWeight = rows.reduce((s, r) => s + (Number(r.weight) || 0), 0)
        this.totalTimes = rows.reduce((s, r) => s + (Number(r.times) || 0), 0)
        const option = this.buildChartOption(labels, series)
        this.chartInstance && this.chartInstance.setOption(option)
      } catch (e) {
        const option = this.buildChartOption([], [])
        this.chartInstance && this.chartInstance.setOption(option)
      }
    }
  }
}
</script>

<style scoped>
.device-stats-container {
  padding: 20px;
}

.box-card {
  border: none;
  border-radius: 8px;
}

.toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.summary {
  margin: 10px 0 6px;
  color: #606266;
}

.summary b {
  color: #303133;
  margin: 0 4px;
}

.chart {
  width: 100%;
  height: 420px;
}
</style>
